export type Rezensionen = {
	name: string;
	rating: number;
	bewertung: string;
};

export const rezensionen: Rezensionen[] = [
	{
		name: 'Andrey M.',
		rating: 5,
		bewertung: 'Hervorragende Beratung, vielen Dank!',
	},
	{
		name: 'Wolfgang Morgenthaler',
		rating: 5,
		bewertung: 'Wir haben für meinen Vater eine neue Hörgeräteversorgung gesucht – und mit Herrn Reifschneider von HörGut in der neuen Filiale in Rheinbischofsheim einen echten Glücksgriff gemacht! Die Beratung war nicht nur fachlich top, sondern auch menschlich einfach großartig: geduldig, individuell und mit spürbarem Engagement. Mein Vater ist mit den neuen Hörgeräten überglücklich und genießt sein wiedergewonnenes Hörvermögen sichtlich.Vielen herzlichen Dank für diese hervorragende Betreuung – wir empfehlen HörGut und Herrn Reifschneider uneingeschränkt weiter!',
	},
	{
		name: 'Wolfgang P.',
		rating: 5,
		bewertung: 'In angenehmer Atmosphäre wird der Kunde kompetent beraten. Dem Kunden wird ausreichend Zeit gewährt, verschiedene Hörgeräte auszuprobieren, um sich für das passende entscheiden zu können. Neben seinem Fachwissen zeigt Herr Reifschneider in seiner empathischen Art viel Geduld und geht stets erklärend und bereitwillig ausprobierend auf Wünsche und Fragen ein. Herzlichen Dank ihm und seiner freundlichen Mitarbeiterin - dem HörGut-Team.',
	},
	{
		name: 'Ralf Zirbes',
		rating: 5,
		bewertung: 'Leider schreibt man viel zu oft nur schlechte Bewertungen. Aber bei dem kleinen Laden an der Bühlot ist es mir einen wichtiges Anliegen positiv zu berichten. Die Beratung, das Fachwissen, die Zeit für Tests und Probehören waren / sind Weltklasse. Niemals hatte ich das Gefühl "hier will mir einer etwas schnell verkaufen", oder man wird hier zum Kauf der hochwertigeren Geräte gedrängt. Ich bin sehr zufrieden und kann hier nur meine Empfehlung aussprechen!',
	},
	{
		name: 'Ingrid Kugel',
		rating: 5,
		bewertung: 'Auf Grund der guten Bewertungen kam ich zu Hör Gut.Kann mich nur anschließen. Fühlte mich vom ersten Termin ,bis zum Kauf sehr gut betreut.Herr Reifschneider mit seiner emphatischen Art,ruhig ,kompetent, geduldig bei jedem Termin,kann ich nur empfehlen. Danke Herr Reifschneider.',
	},
	{
		name: 'Sabine Smith',
		rating: 5,
		bewertung: 'Sehr guter Service. Sehr gute Beratung.',
	},
];
